import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["role", "fieldset", "select"]

  connect() {
    // INTENT: Set the initial visibility and enablement of the branch select field based on the current role when the page loads.
    // EXPECTED OUTCOME: The branch dropdown is correctly shown or hidden matching the user's current database state.
    this.toggle()
  }

  toggle() {
    // INTENT: Get the currently selected role to determine if branch selection is applicable.
    // EXPECTED OUTCOME: A string representing the selected role.
    const role = this.roleTarget.value

    // INTENT: Check if the role is a military-related role (either recruit or recruiter).
    // EXPECTED OUTCOME: A boolean indicating whether branch selection is valid for the role.
    const isMilitary = ["recruit", "recruiter"].includes(role)

    // INTENT: Toggle fieldset visibility, and update field enablement and values based on the role.
    // EXPECTED OUTCOME: Hidden fieldsets are disabled and cleared, preventing them from submitting values.
    if (isMilitary) {
      // INTENT: Display the branch selection field to military users.
      // EXPECTED OUTCOME: The fieldset becomes visible on screen.
      this.fieldsetTarget.classList.remove("hidden")
      this.fieldsetTarget.classList.add("flex")

      // INTENT: Enable the select input so its value is included in the form payload.
      // EXPECTED OUTCOME: The select element is enabled.
      this.selectTarget.disabled = false
    } else {
      // INTENT: Hide the branch selection field for non-military users.
      // EXPECTED OUTCOME: The fieldset is hidden from the UI.
      this.fieldsetTarget.classList.remove("flex")
      this.fieldsetTarget.classList.add("hidden")

      // INTENT: Disable the select input so the browser does not submit its value when submitting the form.
      // EXPECTED OUTCOME: The select element is disabled and excluded from submission.
      this.selectTarget.disabled = true

      // INTENT: Reset the selected branch to a blank string when hidden.
      // EXPECTED OUTCOME: The branch preference is cleared for non-military users.
      // CAVEAT/TRAP: If not cleared and disabled, the hidden field may submit a default option (like 'Army') or retain a stale value.
      this.selectTarget.value = ""
    }
  }
}
